import { render, staticRenderFns } from "./MenuItem.vue?vue&type=template&id=21d4e47f&scoped=true&"
var script = {}
import style0 from "./MenuItem.vue?vue&type=style&index=0&id=21d4e47f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d4e47f",
  null
  
)

export default component.exports